import {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import PageHeader from '../shared/PageHeader/PageHeader';
import PageFooter from '../shared/PageFooter/PageFooter';
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import {getCampaignPageTemplate, getCampaignPage, fetchShareUser} from '_app/mediashare/scenes/CampaignPagePreview/campaignPagePreviewActions';
import {appConfigService, fileTypeService, campaignTrackingService} from '_app/services';
import {getPublicSettings} from '_app/shared/features/officeSettings/officeSettingsActions';
import {defaultSupportUserOfficeDetails, defaultThumbnail, defaultUserInfo} from '_app/mediashare/scenes/CampaignPagePreview/campaignPagePreviewConstants';
import './campaign-Page-Preview.less';
import {Enums} from '_app/utils';

export class CampaignPagePreview extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		const {getCampaignPageTemplate, getCampaignPage, token,
			campaignPageTemplateId, getPublicSettings, isCampaign, getUserInfo, hideDetails} = this.props;

		if (isCampaign.toLowerCase() === 'true') {
			hideDetails && hideDetails.toLowerCase() === 'false' && getCampaignPage(token);
			getUserInfo(token, true);
			getPublicSettings(token, true);
		} else {
			getCampaignPageTemplate(parseInt(campaignPageTemplateId));
		}
	}

	componentDidUpdate() {
		const {jwplayer} = window;
		const {token, pageTemplate, source, userInfo} = this.props;
		const {jwToken, thumbnailLink, basicInfoPosterUrl} = pageTemplate;
		const {abmVideoBranding, logoUrl} = userInfo;
		const imageUrl = thumbnailLink ? `${appConfigService.get('serverPath')}api/v1/StoredFile/${thumbnailLink}/download`
			: basicInfoPosterUrl ? basicInfoPosterUrl : defaultThumbnail;
		const eventTypes = Enums.getType('campaignEventTypes');
		const logo = abmVideoBranding ? {
			file: logoUrl,
			position: 'top-left',
			hide: true
		} : null;

		if (document.getElementById('video')) {
			const player = jwplayer('video')
				.setup({
					file: fileTypeService.videoUrl(jwToken),
					mediaid: jwToken,
					image: imageUrl,
					stretching: 'exactfit',
					logo
				});

			if (token && !this.isPreview()) {
				player.on('firstFrame', () => {
					campaignTrackingService.add({
						token,
						eventType : eventTypes.VIDEO_START,
						source
					});
				});
				player.on('complete', () => {
					campaignTrackingService.add({
						token,
						eventType : eventTypes.VIDEO_COMPLETE,
						source
					});
				});
			}
		}
	}

	isPreview() {
		const {isPreview} = this.props;

		return (isPreview && isPreview.toLowerCase() === 'true');
	}

	isComplianceOrParentCompliance() {
		return (this.props.officeInfo.compliance || this.props.officeInfo.isComplianceParent);
	}

	getContent() {
		const {isUserInfoLoading, userInfo, isLoading, isOfficeInfoLoading, officeInfo, token, hideDetails, source, pageTemplate, recipientID, emailID} = this.props;
		const {compliance, isComplianceParent, disclaimer} = officeInfo;
		let {advisorDisclaimer, complianceID, officeFooter, partnerFooter} = userInfo;
		let {content, pageTemplateCategory} = pageTemplate;

		if (isUserInfoLoading || isLoading || isOfficeInfoLoading) {
			return '<div class="message text-center"><i class="fa fa-spinner fa-pulse fa-3x fa-fw" /></div>';
		} else if (hideDetails && hideDetails.toLowerCase() === 'true') {
			return '<div class="message text-center"><div><i class="fa fa-exclamation-triangle"></i></div>This content is no longer available</div>';
		} else if (content) {
			const formTags = content.match(/<form[^>]*>/g);
			const formTag = formTags ? formTags.length ? formTags[0] : '' : '';
			const replacedFormTag = formTag.replace('action="/action_page.php"',
				` method ="post" action="${appConfigService.get('serverPath')}api/v1/LeadCapture?token=${token}&source=${source}"`);

			content = content.replace(/<video[^>]*>(.*?)<\/video>/g,'<div id="video"></div>');
			content = formTag ? content.replace(formTag, replacedFormTag) : content;

			if (recipientID && parseInt(recipientID) > 0) {
				content = content.replace('</form>', `<input type="hidden" id="recipientID" name="recipientID" value=${recipientID}></form>`);
			}

			if (emailID && parseInt(emailID) > 0) {
				content = content.replace('</form>', `<input type="hidden" id="emailID" name="emailID" value=${emailID}></form>`);
			}

			if (pageTemplateCategory !== 2 && pageTemplateCategory !== 4) {
				if (compliance || isComplianceParent) {
					if (officeInfo.disclaimer) {
						advisorDisclaimer = disclaimer;
					} else if (partnerFooter) {
						advisorDisclaimer = partnerFooter;
					}
					complianceID = null;
				}

				if (advisorDisclaimer) {
					content = content.concat(`<div class="col-md-10 col-md-offset-1 compliance-text">${advisorDisclaimer
						.replace('<img src="/',`<img src="${appConfigService.get('baseDomainName')}/`)}</div>`);
				}

				if (complianceID) {
					content = content.concat(`<div class="col-md-10 col-md-offset-1 compliance-text">${complianceID}</div>`);
				}

				if (officeFooter) {
					content = content.concat(`<div class="col-md-10 col-md-offset-1 compliance-text">${officeFooter}</div>`);
				}
			}

			if (this.isPreview() && pageTemplate.pageTemplateCategory === 1){
				const startPosition = content.search('<button');
				const endPosition = content.search('/button>');
				const buttonCode = content.substring(startPosition, endPosition + 8);
				const toolTipCode = '<div title="The details entered in this form gets submitted by clicking this button. The gated content PDF can be downloaded from the preview of the Thank You email." />';
				const buttonWithTooltipCode = toolTipCode + buttonCode;

				content = buttonCode ? content.replace(/<button[^>]*>(.*?)<\/button>/g,buttonWithTooltipCode) : content;
			}

			return content;
		} else {
			return '<div class="message text-center"><div><i class="fa fa-exclamation-triangle"></i></div>This content is no longer available</div>';
		}
	}

	render() {
		let {userInfo, officeInfo, isOfficeInfoLoading, token} = this.props;
		let headerLogoUrl = userInfo.logoUrl;
		const {isCampaign} = this.props;
		const className = `fr-element fr-view froala-height${this.isPreview() ? ' disable-button' : ''}`;

		if (isCampaign.toLowerCase() === 'false') {
			userInfo = defaultUserInfo;
			officeInfo = defaultSupportUserOfficeDetails;
			headerLogoUrl = this.props.logoUrl;
		}

		return (
			<div className="use-sticky-footer media-share-page full-height">
				<div>
					<div className="with-stickyfooter hero-well bg-color-theme-secondary">
						<PageHeader logoUrl={headerLogoUrl} />
					</div>
					<div className={className}>
						<div dangerouslySetInnerHTML={{
							__html: this.getContent()
						}}
						/>
					</div>
					{!isOfficeInfoLoading &&
					<PageFooter
						office={officeInfo}
						isCampaign
						token={token}
						userInfo={userInfo}
					/>}
				</div>
			</div>

		);
	}
}

CampaignPagePreview.propTypes = {
	getCampaignPageTemplate: PropTypes.func.isRequired,
	pageTemplate: PropTypes.object.isRequired,
	officeInfo: PropTypes.object.isRequired,
	userInfo: PropTypes.object.isRequired,
	logoUrl: PropTypes.string.isRequired,
	campaignPageTemplateId: PropTypes.string.isRequired,
	isCampaign:  PropTypes.string.isRequired,
	token: PropTypes.string.isRequired,
	source: PropTypes.string.isRequired
};

CampaignPagePreview.defaultProps = {
	userInfo: {},
	pageTemplate: {},
	officeInfo: {}
};

const mapStateToProps = (state) => ({
	pageTemplate: state.campaignPagePreview.pageTemplate,
	userInfo: state.campaignPagePreview.userInfo,
	isUserInfoLoading: state.campaignPagePreview.isUserInfoLoading,
	officeInfo: state.office.data,
	isOfficeInfoLoading: state.office.isLoading,
	isLoading: state.campaignPagePreview.isLoading
});

const mapDispatchToProps = {
	getCampaignPageTemplate: getCampaignPageTemplate,
	getCampaignPage: getCampaignPage,
	getUserInfo: fetchShareUser,
	getPublicSettings: getPublicSettings
};

export default connect(mapStateToProps, mapDispatchToProps)(CampaignPagePreview);